// extracted by mini-css-extract-plugin
module.exports = {"MogulPersonContainerMob":"style_MogulPersonContainerMob__mG3gs","MogulPersonMob":"style_MogulPersonMob__36O-_"};